import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useState, useCallback, useEffect } from 'react';
import { isMovable } from '../../helper.js';
import { DrillDownButton, MoveButton } from './ActionButtons.js';
import ShuttleListItem from './ShuttleListItem.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-utilities/utils';
import 'treetabular';
import '@elliemae/ds-classnames';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-icons/ArrowShortRight';
import '@elliemae/ds-icons/ArrowShortReturn';
import 'react-spring/web.cjs';
import '@elliemae/ds-basic/TruncatedTooltipText';
import 'react-sortable-hoc';
import '@elliemae/ds-icons/GripperVertical';

function ShuttleSourceListItem(_ref) {
  var _ref$item = _ref.item,
      item = _ref$item === void 0 ? {} : _ref$item,
      _ref$onItemCheck = _ref.onItemCheck,
      onItemCheck = _ref$onItemCheck === void 0 ? function () {
    return null;
  } : _ref$onItemCheck,
      _ref$onMoveToTarget = _ref.onMoveToTarget,
      onMoveToTarget = _ref$onMoveToTarget === void 0 ? function () {
    return null;
  } : _ref$onMoveToTarget,
      _ref$onNavigateOnSour = _ref.onNavigateOnSourceTo,
      onNavigateOnSourceTo = _ref$onNavigateOnSour === void 0 ? function () {
    return null;
  } : _ref$onNavigateOnSour,
      _ref$isChecked = _ref.isChecked,
      isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
      _ref$showMoveButton = _ref.showMoveButton,
      showMoveButton = _ref$showMoveButton === void 0 ? true : _ref$showMoveButton,
      _ref$showDrillDownBut = _ref.showDrillDownButton,
      showDrillDownButton = _ref$showDrillDownBut === void 0 ? true : _ref$showDrillDownBut;
      _ref.index;
      var rest = _objectWithoutProperties(_ref, ["item", "onItemCheck", "onMoveToTarget", "onNavigateOnSourceTo", "isChecked", "showMoveButton", "showDrillDownButton", "index"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      clicked = _useState2[0],
      setClicked = _useState2[1];

  var moveToTarget = useCallback(function () {
    return onMoveToTarget(item);
  }, [item]);
  useEffect(function () {
    if (clicked) {
      moveToTarget();
    }
  }, [clicked]);
  var navigateOnSourceTo = useCallback(function () {
    return onNavigateOnSourceTo(item);
  }, [item]);
  var checkItem = useCallback(function () {
    if (!clicked) onItemCheck(item);
  }, [item, clicked]);

  var handleOnClick = function handleOnClick() {
    if (!clicked) {
      setClicked(true);
    }
  };

  return /*#__PURE__*/React.createElement(ShuttleListItem, _extends({}, rest, {
    actions: [showDrillDownButton && /*#__PURE__*/React.createElement(DrillDownButton, {
      key: "drill-down",
      disabled: !item.hasChildren && !item.asyncLoad || item.readOnly || item.disableDrillDown,
      onClick: navigateOnSourceTo
    }), showMoveButton && /*#__PURE__*/React.createElement(MoveButton, {
      "data-testid": "ds-shuttle__move-button",
      key: "move",
      disabled: !isMovable(item) || item.readOnly,
      onClick: handleOnClick
    })],
    isChecked: isChecked,
    item: item,
    onSelect: checkItem
  }));
}

export default ShuttleSourceListItem;
//# sourceMappingURL=ShuttleSourceListItem.js.map
